<script lang="ts" setup>
export interface TcTagProps {
  size?: "large" | "small";
  link?: string;
}

const props = withDefaults(defineProps<TcTagProps>(), { size: "large" });
</script>
<template>
  <div class="tag" :class="`tag--${props.size}`">
    <a v-if="props.link" class="tag__link" :href="link">
      <slot />
    </a>

    <p v-else><slot /></p>
  </div>
</template>

<style lang="scss" scoped>
.tag {
  @include colors.color(content, high);
  @include colors.bg(content, low);

  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  border-radius: $space-1;
  min-width: 35px;
  width: fit-content;

  &__link {
    @include colors.color(content, high);

    text-decoration: none;
  }

  &__link:visited {
    @include colors.color(content, high);

    text-decoration: none;
  }

  &--small {
    @include text.general(low, m);
    @include sp.padding(x, 2);
    @include sp.padding(y, 1);
  }

  &--large {
    @include text.general(high, l);
    @include sp.padding(y, 2);
    @include sp.padding(x, 4);
  }
}
</style>
